"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CogFactory = exports.Cog = void 0;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const pickRandom = arr => arr[Math.floor(Math.random() * arr.length)];
const positionsMap = {
  bottom: {
    0: -50 + 10,
    1: 35 + 10,
    2: 120 + 10,
    3: 205 + 10
  },
  middle: {
    0: 120 + 10,
    1: 205 + 10,
    2: 290 + 10,
    3: 375 + 10
  },
  top: {
    0: 330 + 10,
    1: 415 + 10,
    2: 500 + 10,
    3: 585 + 10
  },
  'top-bottom': {
    0: -50 + 10,
    1: 35 + 10,
    2: 500 + 10,
    3: 585 + 10
  }
};
class CogFactory {
  constructor(scene) {
    _defineProperty(this, "possiblePositions", ["bottom", "top", "middle", "top-bottom"]);
    this.scene = scene;
  }
  create(obstaclesGroup) {
    const groupXPosition = Phaser.Math.Between(this.scene.scale.width, this.scene.scale.width * 1.8);
    const numberOfCogs = Math.floor(Math.random() * 3) + 2;
    const position = pickRandom(this.possiblePositions);
    for (let i = 0; i < numberOfCogs; i++) {
      const cog = new Cog(this.scene, position, i, groupXPosition);
      obstaclesGroup.add(cog);
    }
    //     {const numberOfCogs = 4
    //     const position = "top";
    //     const groupXPosition = 100;
    //     console.log(`Creating ${numberOfCogs} cogs at ${position}`);
    //     for (let i = 0; i < numberOfCogs; i++) {
    //         const cog = new Cog(this.scene, position, i, groupXPosition);
    //         obstaclesGroup.add(cog);
    //     }}
    //    { const numberOfCogs = 4
    //     const position = "middle";
    //     const groupXPosition = 200;
    //     console.log(`Creating ${numberOfCogs} cogs at ${position}`);
    //     for (let i = 0; i < numberOfCogs; i++) {
    //         const cog = new Cog(this.scene, position, i, groupXPosition);
    //         obstaclesGroup.add(cog);
    //     }}
    //    { const numberOfCogs = 4
    //     const position = "bottom";
    //     const groupXPosition = 300;
    //     console.log(`Creating ${numberOfCogs} cogs at ${position}`);
    //     for (let i = 0; i < numberOfCogs; i++) {
    //         const cog = new Cog(this.scene, position, i, groupXPosition);
    //         obstaclesGroup.add(cog);
    //     }}
    //     { const numberOfCogs = 4
    //         const position = "top-bottom";
    //         const groupXPosition = 400;
    //         console.log(`Creating ${numberOfCogs} cogs at ${position}`);
    //         for (let i = 0; i < numberOfCogs; i++) {
    //             const cog = new Cog(this.scene, position, i, groupXPosition);
    //             obstaclesGroup.add(cog);
    //         }}
  }
}
exports.CogFactory = CogFactory;
class Cog extends Phaser.Physics.Arcade.Sprite {
  constructor(scene, position, place, groupXPosition) {
    const x = 0;
    const y = 0;
    super(scene, x, y, "cog");
    this.scene = scene;
    this.position = position;
    this.place = place;
    this.groupXPosition = groupXPosition;
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.init();
    this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);
  }
  init() {
    this.setOrigin(0, 1).setCollideWorldBounds(true).setBodySize(180, 180).setOffset(-15, 30).setDepth(2).setAngle(-27); // Rotate the cog by 60 degrees

    // Handle resizing
    this.scene.scale.on('resize', this.scaleToFit, this);
    this.scene.scale.on('resize', this.positionOnSky, this);
    this.scaleToFit();
    this.positionOnSky();
  }
  positionOnSky() {
    var _this$scene$sky;
    const gameHeight = this.scene.scale.height;
    const cogHeight = positionsMap[this.position][this.place] * (((_this$scene$sky = this.scene.sky) === null || _this$scene$sky === void 0 ? void 0 : _this$scene$sky.scaleFactors.height) || 1);

    // Position Cog at the bottom of the scaled background
    const skyHeight = this.scene.scale.height;
    const y = gameHeight - (gameHeight - skyHeight) - cogHeight; // Slight offset for alignment
    this.setY(y - 10);
    this.setX(this.groupXPosition);
  }
  scaleToFit() {
    var _this$scene$sky2;
    // Use the scale factor from the Sky class to maintain consistency
    const scaleFactor = ((_this$scene$sky2 = this.scene.sky) === null || _this$scene$sky2 === void 0 ? void 0 : _this$scene$sky2.scaleFactors.height) || 1;
    const width = 85;
    const height = 85;

    // Apply the scale factor to the Cog
    this.setDisplaySize(width * scaleFactor, height * scaleFactor);
  }
  update() {}
}
exports.Cog = Cog;